
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/i/[item]",
      function () {
        return require("private-next-pages/i/[item].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/i/[item]"])
      });
    }
  